export default __webpack_public_path__ + "static/media/P_20180711_145818.3cec0991.jpg";